import FontLoader, { FontFaceObserver } from '@swey/heyday-base/js/services/FontLoader';

export default function loadFonts(): void {
	// Roboto
	// const roboto = new FontFaceObserver('Roboto', {
	// 	weight: 400
	// });
	// const robotoBold = new FontFaceObserver('Roboto', {
	// 	weight: 700
	// });
	// const robotoBlack = new FontFaceObserver('Roboto', {
	// 	weight: 900
	// });

	// Roboto Condensed
	const robotoCondensed = new FontFaceObserver('Roboto Condensed', {
		weight: 400
	});

	const robotoCondensedBold = new FontFaceObserver('Roboto Condensed', {
		weight: 700
	});

	const fontLoader = new FontLoader();
	// fontLoader.addGroup('wf-roboto-loaded', [roboto, robotoBold, robotoBlack]);
	fontLoader.addGroup('wf-roboto-condensed-loaded', [robotoCondensed, robotoCondensedBold]);
	fontLoader.start();
}
